import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { CREATE_CIRCULAR_ROUTE } from "Announcements/modules/constants";
export default store => ({
  path: `circulars/${CREATE_CIRCULAR_ROUTE}`,
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-communications" */ "./components"
        ),
        import(
          /* webpackChunkName: "administrator-communications" */ "Announcements/modules/AnnouncementModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module1 = importedModule1;
        const reducer = module1.default;
        const key = module1.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
